import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { markdownComponents } from 'components/chat-components/AgentMessage.markdown'
import styles from 'components/chat-components/AgentMessage.module.css'

import type { TextContent } from 'components/chat-components/AgentMessage.types'
import type { ReactElement } from 'react'

export const TextRenderer = ({ content }: { content: TextContent }): ReactElement => {
  /* --- Section 6: Render --- */
  return (
    <div className={styles.contentText}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {content.text}
      </ReactMarkdown>
    </div>
  )
}
